import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSentry } from "./sentry";

// Initialise Sentry before the app mounts so all errors are captured
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
